import styled from "styled-components";

export const AddModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;

  .input {
    margin-bottom: 1rem;
  }

  .divider {
    margin: 1rem 0;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-compatibility: textfield;
  }
`;
